<div [classList]="canvas">
    <div id="mySidepanel" [classList]="open1">
        <div fxLayout="column wrap" fxFlex="100" class="editForm">
            <div class="headContent">
                <span class="head"> <b>Add Company</b></span>
                <i id="closeX" (click)="closeEdit()" class="flaticon-close"></i>
            </div>
            <logzy-quick-add-company [bindCompany]="bindCompany"
                (companyAdded)="bindAddedCompany($event)"></logzy-quick-add-company>
        </div>
    </div>
</div>
<logzy-lead-verification (newCompanyData)="openEdit($event)"
    [getAddedCompany]="bindNewCompany"></logzy-lead-verification>

<!-- <logzy-lead-create (newCompanyData)="openEdit($event)" [getAddedCompany]="bindNewCompany"></logzy-lead-create> -->
